import { Badge, BadgeColorVariant, BadgeProps, BadgeVariant } from "@/components/ui/badge";
import { EmptyValue } from "@/components/ui/empty-value";
import type { ReactNode } from "react";

export interface BadgeListItem {
  key: string;
  label: ReactNode;
  variant?: BadgeProps["variant"];
  colorVariant?: BadgeProps["colorVariant"];
}

export function BadgeList({ items }: { items: BadgeListItem[] }) {
  if (items.length === 0) {
    return (
      <div className="text-left">
        <EmptyValue />
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-1 pr-1">
      {items.map((item) => (
        <Badge
          variant={item.variant ?? BadgeVariant.Outlined}
          colorVariant={item.colorVariant ?? BadgeColorVariant.Secondary}
          key={item.key}
        >
          {item.label}
        </Badge>
      ))}
    </div>
  );
}
